import { PATIENT } from "../constants";
import { instance } from "../../axios";
import { store } from "../../store";

let getPatientsAction = () => {
  return (dispatch) => {
    dispatch({
      type: PATIENT.GET_PATIENTS,
    });
    instance
      .get(
        `/patient?limit=${store.getState().patient.limit || 20}&offset=${
          store.getState().patient.offset
        }&query=${encodeURI(store.getState().patient.query)}&noSubscription=${
          store.getState().patient.noSubscription
        }&moduleFilter=${encodeURI(store.getState().patient.moduleFilter || "")}`
      )
      .then((results) => {
        dispatch({
          type: PATIENT.GET_PATIENTS_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: PATIENT.GET_PATIENTS_FAILURE,
          payload: error,
        });
      });
  };
};

let getPatientAction = (id) => {
  return (dispatch) => {
    dispatch({
      type: PATIENT.GET_PATIENT,
    });
    instance
      .get("/patient/" + id)
      .then((results) => {
        dispatch({
          type: PATIENT.GET_PATIENT_SUCCESS,
          payload: results.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: PATIENT.GET_PATIENTS_FAILURE,
          payload: error,
        });
      });
  };
};

let createPatientAction = (body) => {
  return (dispatch) => {
    dispatch({
      type: PATIENT.CREATE_PATIENT,
    });
    return instance
      .post("/patient", body)
      .then((results) => {
        dispatch({
          type: PATIENT.CREATE_PATIENT_SUCCESS,
          payload: results.data,
        });
        dispatch(getPatientsAction());
        return results;
      })
      .catch((error) => {
        dispatch({
          type: PATIENT.CREATE_PATIENT_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

let updatePatientAction = (body) => {
  return (dispatch) => {
    dispatch({
      type: PATIENT.CREATE_PATIENT,
    });
    return instance
      .post("/patient/" + body.id, body)
      .then((results) => {
        dispatch({
          type: PATIENT.CREATE_PATIENT_SUCCESS,
          payload: results.data,
        });
        dispatch(getPatientsAction());
        return results;
      })
      .catch((error) => {
        dispatch({
          type: PATIENT.CREATE_PATIENT_FAILURE,
          payload: error,
        });
        throw error;
      });
  };
};

let deletePatientAction = (id) => {
  return (dispatch) => {
    dispatch({
      type: PATIENT.DELETE_PATIENT,
    });
    instance
      .delete("/patient/" + id)
      .then((results) => {
        dispatch({
          type: PATIENT.DELETE_PATIENT_SUCCESS,
          payload: results.data,
        });
        dispatch(getPatientsAction());
      })
      .catch((error) => {
        dispatch({
          type: PATIENT.DELETE_PATIENT_FAILURE,
          payload: error,
        });
      });
  };
};

let cleanPatientAction = () => {
  return (dispatch) => {
    dispatch({
      type: PATIENT.CLEAN_PATIENT,
    });
  };
};

let cleanPatientErrorAction = () => {
  return (dispatch) => {
    dispatch({
      type: PATIENT.CLEAN_ERROR,
    });
  };
};

let setOffset = (offset) => {
  return (dispatch) => {
    dispatch({
      type: PATIENT.SET_OFFSET,
      payload: offset,
    });
    dispatch(getPatientsAction());
  };
};

let setQuery = (query) => {
  return (dispatch) => {
    dispatch({
      type: PATIENT.SET_QUERY,
      payload: query,
    });
    dispatch(getPatientsAction());
  };
};

let setNoSubscription = (value) => {
  return (dispatch) => {
    dispatch({
      type: PATIENT.SET_NO_SUBSCRIPTION,
      payload: value,
    });
    dispatch(getPatientsAction());
  };
};

let setModuleFilter = (value) => {
  return (dispatch) => {
    dispatch({
      type: PATIENT.SET_MODULE_FILTER,
      payload: value,
    });
    dispatch(getPatientsAction());
  };
};

export {
  getPatientsAction,
  createPatientAction,
  cleanPatientAction,
  updatePatientAction,
  deletePatientAction,
  getPatientAction,
  setOffset,
  setQuery,
  setNoSubscription,
  setModuleFilter,
  cleanPatientErrorAction,
};
